import { Auth } from "aws-amplify";
import axios from "axios";

const ACS_API_BASE_URL = process.env.MAIN_API;

class ShipmentInquiriesService {
  async getInquiryList() {
    let myInit = {
      params: {},
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };

    return await axios.get(ACS_API_BASE_URL + "/order/get_orders", myInit);
  }

  async getFileList(inquiryId) {
    let myInit = {
      // params: { inquiryId },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };

    return await axios.get(ACS_API_BASE_URL + "/order/get_orders", myInit);
  }

  async getInquiryHistory(order_id) {
    let myInit = {
      params: { order_id },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };

    return await axios.get(
      ACS_API_BASE_URL + "/order/get_edit_history",
      myInit
    );
  }

  async updateOrder(formData) {
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };
    let body = formData;

    return await axios.post(
      ACS_API_BASE_URL + "/order/update_order",
      body,
      myInit
    );
  }

  async updateStatusToBAH(payload) {
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };
    let body = payload;

    return await axios.post(
      ACS_API_BASE_URL + "/order/update_status_to_BAH",
      body,
      myInit
    );
  }

  async addShipment(payload) {
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };
    let body = payload;

    return await axios.post(
      ACS_API_BASE_URL + "/order/add_shipment",
      body,
      myInit
    );
  }

  async assignInventoryCodesUploadFile(payload) {
    let myInit = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };
    let body = payload;
    return await axios.post(
      ACS_API_BASE_URL + "/order/add_shipment/file",
      body,
      myInit
    );
  }

  async uploadManifestFile(payload) {
    let myInit = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };
    let body = payload;
    return await axios.post(
      ACS_API_BASE_URL + "/order/manifest/upload",
      body,
      myInit
    );
  }

  async downloadManifestFile(file_key) {
    let myInit = {
      params: { file_key },
      headers: {
        // "Content-Type": "multipart/form-data",
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };
    return await axios.get(
      ACS_API_BASE_URL + "/order/manifest/download",
      myInit
    );
  }

  async assignUnassignInventoryCodes(payload) {
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };
    let body = payload;
    return await axios.post(
      ACS_API_BASE_URL + "/order/assign_inventory_codes",
      body,
      myInit
    );
  }

  async markShippedUnshipped(endpoint, payload) {
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };
    let body = payload;
    return await axios.post(ACS_API_BASE_URL + endpoint, body, myInit);
  }

  async unassignInventoryCodes(payload) {
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };
    let body = payload;
    return await axios.post(
      ACS_API_BASE_URL + "/order/unassign_inventory_codes",
      body,
      myInit
    );
  }

  async getUnassignedItems(inquiry_id) {
    let myInit = {
      params: { inquiry_id },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };

    return await axios.get(
      ACS_API_BASE_URL + "/order/get_unassigned_inventory_codes",
      myInit
    );
  }

  async getShipmentList(inquiry_id) {
    let myInit = {
      params: { inquiry_id },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };
    return await axios.get(
      ACS_API_BASE_URL + "/order/get_inquiry_shipments",
      myInit
    );
  }

  async getShipmentDetailsList(inquiry_id) {
    let myInit = {
      params: { inquiry_id },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };
    return await axios.get(
      ACS_API_BASE_URL + "/order/get_inquiry_shipment_details",
      myInit
    );
  }

  async uploadManifest(inquiryId, shipmentName, file) {
    let myInit = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };

    const formData = new FormData();
    formData.append("file", file);
    formData.append("inquiry_id", inquiryId);
    formData.append("shipment_name", shipmentName);

    return await axios.post(
      ACS_API_BASE_URL + "/order/manifest/upload",
      formData,
      myInit
    );
  }

  async saveTrackingInfo(payload) {
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };
    // Use the absolute URL as requested
    return await axios.post(
      ACS_API_BASE_URL + "/order/add_tracking_details",
      payload,
      myInit
    );
  }
}

export default new ShipmentInquiriesService();
